"use client"

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog"
import { useTranslations } from "next-intl"


interface DisableGroupsConfirmProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
}

export function DisableGroupsConfirm({ open, onOpenChange, onConfirm }: DisableGroupsConfirmProps) {
  const tUi = useTranslations("Shopify.ShopifyAttributionDashboardDialogsDisableGroupsConfirm")
  const tCommonUi = useTranslations("Common")

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle><span key={tUi("disableORGroups")}>{tUi("disableORGroups")}</span></AlertDialogTitle>
          <AlertDialogDescription>
            <span key={tUi("theBaseRuleAndEveryGroupMergeInto")}>{tUi("theBaseRuleAndEveryGroupMergeInto")}</span></AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel><span key={tCommonUi("cancel")}>{tCommonUi("cancel")}</span></AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}><span key={tUi("disableGroups")}>{tUi("disableGroups")}</span></AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
